import type { ReactNode } from "react"

import { FilterAltRounded } from "@mui/icons-material"
import { Chip, Typography } from "@mui/material"
import { Flex, FlexColumn } from "components/common/StyledComponents"
import SurfacePaper from "components/common/SurfacePaper"

type Props = {
  children: ReactNode
  headerAction?: ReactNode
  resultLabel: string
}

const DataViewFilterSurface = ({ children, headerAction, resultLabel }: Props) => {
  return (
    <SurfacePaper sx={{ p: 2 }} variant="outlined">
      <FlexColumn gap={1.5}>
        <Flex alignItems="center" gap={1} justifyContent="space-between">
          <Flex alignItems="center" className="flex-wrap" gap={1}>
            <FilterAltRounded color="primary" fontSize="small" />
            <Typography variant="subtitle2">Bộ lọc</Typography>
            {headerAction}
          </Flex>
          <Chip label={resultLabel} size="small" />
        </Flex>
        {children}
      </FlexColumn>
    </SurfacePaper>
  )
}

export default DataViewFilterSurface
